const isUrl = (input: string): boolean => {
  return (
    input.includes('://') || input.includes('.com') || input.includes('.co')
  )
}

export const buildSocialMediaUrl = (
  input: string,
  platform:
    | 'linkedInUrl'
    | 'instagramUrl'
    | 'twitterUrl'
    | 'facebookUrl'
    | 'tikTokUrl'
    | 'pinterestUrl'
    | 'redditUrl',
): string => {
  if (!input || input.trim() === '') return ''

  if (isUrl(input)) {
    return input
  }

  let username = input.trim().replace(/^@/, '')

  switch (platform) {
    case 'linkedInUrl':
      return `https://linkedin.com/in/${username}`

    case 'instagramUrl':
      return `https://instagram.com/${username}`

    case 'twitterUrl':
      return `https://x.com/${username}`

    case 'facebookUrl':
      return `https://facebook.com/${username}`

    case 'tikTokUrl':
      if (!username.startsWith('@')) {
        username = `@${username}`
      }
      return `https://www.tiktok.com/${username}`

    case 'pinterestUrl':
      return `https://pinterest.com/${username}`

    case 'redditUrl':
      return `https://reddit.com/user/${username}`

    default:
      return input
  }
}
